export const bulkUploadErrors = {
  BLK_01: {
    error_text: "Duplicates found for provided data",
    error_description:
      "System has detected that for the provided data, there are already a duplicate info present. So not able to proceed further. For more information, please click on 'Help Link'.",
    help_link: "Link",
  },
  BLK_02: {
    error_text: "Required columns are missing",
    error_description:
      "Check the columns in the uploaded sheet, as system observed some columns missing. Check the spellings of the column so that its matched with on how its in sample file.",
    help_link: "Link",
  },
  BLK_03: {
    error_text: "Format of duration is not as expected",
    error_description:
      "The required format of duration and what was provided is mismatched. The system expected format is like 'Month_Name-Year'. examples are Jan-2023, Sept-2024, Dec-2024, Mar-2022 etc.",
    help_link: "Link",
  },
  BLK_04: {
    error_text:
      "Data in Preferred Emission Source column is missing. It required to proceed",
    error_description:
      "Emission Source is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_05: {
    error_text: "Preferred Emission Source is not as expected",
    error_description:
      "Emision Source text is not matching the expected text. Please cross check and upload again. ",
    help_link: "Link",
  },
  BLK_06: {
    error_text:
      "Data in Log Emission Against column is missing. It required to proceed",
    error_description:
      "Log Emission Against is a must information, without which the information cannot be processed by the system. Please provide this required information. ",
    help_link: "Link",
  },
  BLK_07: {
    error_text: "Log Emission Against is not as expected",
    error_description:
      "Log Emission Against text is not matching the expected text. Please cross check and upload again. ",
    help_link: "Link",
  },
  BLK_08: {
    error_text: "Activity Data column is missing. It required to proceed",
    error_description:
      "Activity Data is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_09: {
    error_text: "Activity Data is not as expected",
    error_description:
      "Activity Data text is not matching the expected text. Please cross check and upload again. ",
    help_link: "Link",
  },
  BLK_10: {
    error_text:
      "Data in Consumption Value column is missing. It required to proceed",
    error_description:
      "Consumption Value is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_11: {
    error_text: "Consumption Value is not as expected",
    error_description:
      "Consumption Value text is not matching the expected text. Please cross check and upload again. ",
    help_link: "Link",
  },
  BLK_12: {
    error_text:
      "Unit of Measure Value column is missing. It required to proceed",
    error_description:
      "Unit of Measure is a must information, without which the information cannot be processed by the system. Please provide this required information. ",
    help_link: "Link",
  },
  BLK_13: {
    error_text: "Unit of Measure Value is not as expected",
    error_description:
      "Unit of Measure text is not matching the expected text. Please cross check and upload again. ",
    help_link: "Link",
  },
  BLK_14: {
    error_text: "No emission factor found",
    error_description:
      "System has detected that for the provided data combination, there is no emission factor. So not able to proceed further. For more information. ",
    help_link: "Link",
  },
  BLK_SLR_01: {
    error_text: "Duplicates found for provided data",
    error_description:
      "System has detected that for the provided data, there are already a duplicate info present. So not able to proceed further. For more information, please click on 'Help Link'",
    help_link: "Link",
  },
  BLK_SLR_02: {
    error_text: "Required columns are missing",
    error_description:
      "Check the columns in the uploaded sheet, as system observed some columns missing. Check the spellings of the column so that its matched with on how its in sample file.",
    help_link: "Link",
  },
  BLK_SLR_03: {
    error_text:
      "Data in Company name column is missing. It required to proceed.",
    error_description:
      "Company name is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_04: {
    error_text:
      "Data in Primary contact name column is missing. It required to proceed.",
    error_description:
      "Primary contact name is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_05: {
    error_text:
      "Data in Primary contact email ID column is missing. It required to proceed.",
    error_description:
      "Primary contact email ID is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_06: {
    error_text:
      "Data in Secondary contact name column is missing. It required to proceed.",
    error_description:
      "Primary contact email ID is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_07: {
    error_text:
      "Data in Secondary contact email ID column is missing. It required to proceed.",
    error_description:
      "Primary Secondary contact email ID is a must information, without which the information cannot be processed by the system. Please provide this required information. ",
    help_link: "Link",
  },
  BLK_SLR_08: {
    error_text:
      "Data in Industry type column is missing. It required to proceed.",
    error_description:
      "Industry type is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_09: {
    error_text:
      "Data in Registration ID column is missing. It required to proceed.",
    error_description:
      "Registration ID is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_10: {
    error_text:
      "Data in Frequency of data request column is missing. It required to proceed.",
    error_description:
      "Frequency of data request is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_11: {
    error_text:
      "Data in Creation Status column is missing. It required to proceed.",
    error_description:
      "Creation Status is a must information, without which the information cannot be processed by the system. Please provide this required information.",
    help_link: "Link",
  },
  BLK_SLR_12: {
    error_text: "Column Text is not matching to expected.",
    error_description:
      "The text for this column is not exactly matching with what is expected by the CMS. Please cross check and upload again.",
    help_link: "Link",
  },
};
